module.exports = __webpack_public_path__ + "f42bf3e90ecf34acc7f008d949ad9125.fbx";